import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ClienteInserirComponent } from "./cliente-inserir.component"; 
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { ClienteInserirRoutingModule } from "./cliente-inserir-routing.module";
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';

@NgModule({
    imports: [
        CommonModule,            
        ClienteInserirRoutingModule,
        FormsModule,
        TableModule,       
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule
    ],
    declarations: [ClienteInserirComponent]
})
export class ClienteInserirModule { }
